import React, { useState } from "react";
import "./style.css";
import OrderHistory from "../OrderHistory";
import LastOrder from "../LastOrder";
import { Button } from "@chakra-ui/react";
import { ArrowRightIcon } from "../../Assets/images/svgs";
import { useNavigate } from "react-router-dom";
import PATHS from "../../Routes/paths";

const OrderHistoryOverview = ({ widget }) => {
  const [ orderId, setOrderId ] = useState(null);
  const navigate = useNavigate();

  const handleThisOrderClick = () => {
    if (!orderId) return;

    if (widget.order) navigate(`${PATHS.ORDERS_OVERVIEW}/${PATHS.ORDER_DETAIL}?idx=${orderId}`);
    else navigate(`${PATHS.SHIPMENT_OVERVIEW}${PATHS.ORDERS_OVERVIEW}/${PATHS.ORDER_DETAIL}?shipId=${orderId}`);
  }

  const children = (
    <Button className="view-this-order-button" onClick={handleThisOrderClick}>
      {`View this ${widget.order ? "order" : "shipment"}`}
      <ArrowRightIcon />
    </Button>
  );

  return (
    <div className={`order-history-overview ${widget.order ? "is-order" : "is-shipment"}`}>
      <LastOrder children={children} onOrderDetails={setOrderId}  hideAdditionalBtns={true} title={`Recent ${widget.order ? "Order" : "Shipment"} Status`} isShipmentOverviewPage={!widget.order} isShipmentTimeLine={!widget.order} />
      <OrderHistory order={widget.order} />
    </div>
  )
}

export default OrderHistoryOverview
